// Legal copy ported verbatim from the QuickScore API's privacy-policy.html
// (the website is now the canonical home; the API copy is being sunset).
export const privacyHtml = `<h1>QuickScore Privacy Policy</h1>
    <p><strong>Effective date:</strong> 2026-07-06</p>
    <div>
      <p>
        <strong>QuickScore</strong>
        is committed to protecting your privacy and developing technology that gives you the most powerful and safe online experience. This Statement of Privacy applies to the <strong>QuickScore</strong>
        Web site and governs data collection and usage. By using the <strong>QuickScore</strong>
        website, you consent to the data practices described in this statement.
      </p>
      <h2 id="collection-of-your-personal-information">Collection of your Personal Information</h2>
      <p>
        <strong>QuickScore</strong>
        collects personally identifiable information, such as your e-mail address, name, home or work address or telephone number. <strong>QuickScore</strong>
        also collects anonymous demographic information, which is not unique to you, such as your ZIP code, age, gender, preferences, interests and favorites.
      </p>
      <p>
        There is also information about your computer hardware and software that is automatically collected by <strong>QuickScore</strong>
        . This information can include: your IP address, browser type, domain names, access times and referring Web site addresses. This information is used by <strong>QuickScore</strong>
        for the operation of the service, to maintain quality of the service, and to provide general statistics regarding use of the<strong>QuickScore</strong>
        Web site.
      </p>
      <p>
        Please keep in mind that if you directly disclose personally identifiable information or personally sensitive data through <strong>QuickScore</strong>
        public message boards, this information may be collected and used by others. Note: <strong>QuickScore</strong>
        does not read any of your private online communications.
      </p>
      <p>
        <strong>QuickScore</strong>
        encourages you to review the privacy statements of Web sites you choose to link to from <strong>QuickScore</strong>
        so that you can understand how those Web sites collect, use and share your information. <strong>QuickScore</strong>
        is not responsible for the privacy statements or other content on Web sites outside of the QuickScore and <strong>QuickScore</strong>
        family of Web sites.
      </p>
      <h2 id="use-of-your-personal-information">Use of your Personal Information</h2>
      <p>
        <strong>QuickScore</strong>
        collects and uses your personal information to operate the site and deliver the services you have requested. QuickScore also uses your personally identifiable information to inform you of other products or services available from <strong>QuickScore</strong>
        and its affiliates. QuickScore may also contact you via surveys to conduct research about your opinion of current services or of potential new services that may be offered.
      </p>
      <p>
        <strong>QuickScore</strong>
        does not sell, rent or lease its customer lists to third parties.<strong>QuickScore</strong>
        may, from time to time, contact you on behalf of external business partners about a particular offering that may be of interest to you. In those cases, your unique personally identifiable information (e-mail, name, address, telephone number) is not transferred to the third party. In addition, <strong>QuickScore</strong>
        may share data with trusted partners to help us perform statistical analysis, send you email or postal mail, provide customer support, or arrange for deliveries. All such third parties are prohibited from using your personal information except to provide these services to <strong>QuickScore</strong>
        , and they are required to maintain the confidentiality of your information.
      </p>
      <p>
        <strong>QuickScore</strong>
        does not use or disclose sensitive personal information, such as race, religion, or political affiliations, without your explicit consent.
      </p>
      <p>
        <strong>QuickScore</strong>
        keeps track of the Web sites and pages our customers visit within<strong>QuickScore</strong>
        , in order to determine what <strong>QuickScore</strong>
        services are the most popular. This data is used to deliver customized content and advertising within<strong>QuickScore</strong>
        to customers whose behavior indicates that they are interested in a particular subject area.
      </p>
      <p>
        <strong>QuickScore</strong>
        Web sites will disclose your personal information, without notice, only if required to do so by law or in the good faith belief that such action is necessary to: (a) conform to the edicts of the law or comply with legal process served on <strong>QuickScore</strong>
        or the site; (b) protect and defend the rights or property of<strong>QuickScore</strong>
        ; and, (c) act under exigent circumstances to protect the personal safety of users of <strong>QuickScore</strong>
        , or the public.
      </p>
      <h2 id="use-of-cookies">Use of Cookies</h2>
      <p>
        The <strong>QuickScore</strong>
        Web site use “cookies” to help you personalize your online experience. A cookie is a text file that is placed on your hard disk by a Web page server. Cookies cannot be used to run programs or deliver viruses to your computer. Cookies are uniquely assigned to you, and can only be read by a web server in the domain that issued the cookie to you.
      </p>
      <p>
        One of the primary purposes of cookies is to provide a convenience feature to save you time. The purpose of a cookie is to tell the Web server that you have returned to a specific page. For example, if you personalize <strong>QuickScore</strong>
        pages, or register with <strong>QuickScore</strong>
        site or services, a cookie helps <strong>QuickScore</strong>
        to recall your specific information on subsequent visits. This simplifies the process of recording your personal information, such as billing addresses, shipping addresses, and so on. When you return to the same <strong>QuickScore</strong>
        Web site, the information you previously provided can be retrieved, so you can easily use the <strong>QuickScore</strong>
        features that you customized.
      </p>
      <p>
        You have the ability to accept or decline cookies. Most Web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies if you prefer. If you choose to decline cookies, you may not be able to fully experience the interactive features of the <strong>QuickScore</strong>
        services or Web sites you visit.
      </p>
      <h2 id="security-of-your-personal-information">Security of your Personal Information</h2>
      <p>
        <strong>QuickScore</strong>
        secures your personal information from unauthorized access, use or disclosure. <strong>QuickScore</strong>
        secures the personally identifiable information you provide on computer servers in a controlled, secure environment, protected from unauthorized access, use or disclosure. When personal information (such as a credit card number) is transmitted to other Web sites, it is protected through the use of encryption, such as the Secure Socket Layer (SSL) protocol.
      </p>
      <h2 id="changes-to-this-statement">Changes to this Statement</h2>
      <p>
        <strong>QuickScore</strong>
        will occasionally update this Statement of Privacy to reflect company and customer feedback. <strong>QuickScore</strong>
        encourages you to periodically review this Statement to be informed of how <strong>QuickScore</strong>
        is protecting your information.
      </p>
      <h2 id="contact-information">Contact Information</h2>
      <p>
        <strong>QuickScore</strong>
        welcomes your comments regarding this Statement of Privacy. If you believe that <strong>QuickScore</strong>
        has not adhered to this Statement, please contact <strong>QuickScore</strong>
        at
        <strong>
          <a href="mailto:manalo.rommel@gmail.com">manalo.rommel@gmail.com</a>
        </strong>
        (Rommel Manalo). We will use commercially reasonable efforts to promptly determine and remedy the problem.
      </p>
    </div>
`
